export default {
  list: [],
  errors: null
};
